"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeValueAsKey = void 0;
/**
 * Creates a new object with the values of the input object as both keys and values.
 *
 * @typeParam T - The type of the input object containing translations.
 * @param keys - An object containing translations.
 * @returns A new object where keys and values are the same.
 */
const makeValueAsKey = keys => Object.fromEntries(Object.entries(keys).map(([key, value]) => [value, value]));
exports.makeValueAsKey = makeValueAsKey;
//# sourceMappingURL=makeValueAsKey.js.map